import React from 'react'
import AcoesPedido from './AcoesPedido';
import DetalhesPedido from './DetalhesPedido';
import ReactTooltip from 'react-tooltip';
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras';
import { validaPerfis } from '../../security/Autorizacao';
import { PERFIL_ADMIN } from '../../security/securityContext';

export class Pedido extends React.Component {
  exibirIcone () {
    if (this.props.pedido.exibirDetalhe) {
      return <i className="material-icons" style={{ cursor: 'pointer' }} onClick={() => this.props.alterarExibicao(this.props.pedido)}>
        &#xE5C7;</i>
    }
    return <i className="material-icons" style={{ cursor: 'pointer' }} onClick={() => this.props.alterarExibicao(this.props.pedido)}>&#xE5C5;</i>
  }

  copyLink(event) {
    event.preventDefault();
    navigator.clipboard.writeText(this.props.pedido.codigoTransacao);

  }

  groupArrayOfObjects (list, key) {
    return list.reduce((rv, x) => {
      // eslint-disable-next-line no-param-reassign
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  }

  exibirTextoIdaVolta () {
    if (Object.entries(this.groupArrayOfObjects(this.props.pedido.reservas, 'itinerarioId')).length > 1) {
      return  <a title='Passagem de ida e volta' className="idaVolta" style={{ cursor: 'pointer' }} onClick={() => this.props.alterarExibicao(this.props.pedido)}>
         Ida/Volta</a>
     }
     return  <a title='Passagem de ida' className="ida" style={{ cursor: 'pointer' }} onClick={() => this.props.alterarExibicao(this.props.pedido)}>
       Ida</a>
  }

  recuperaFormaPagamento () {        
    let labelCartao = ''
    let cartao = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'Cartão').length > 0;    
    const cartaoCredito = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'Cartão de crédito').length > 0;
    const cartaoDebito = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'Cartão de débito').length > 0;
    const tef = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'TEF').length > 0;    
    cartao = cartao || cartaoCredito || cartaoDebito || tef
    
    if (cartao) {
      labelCartao = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'Cartão' || it.tipo === 'Cartão de crédito' || it.tipo === 'Cartão de débito' || it.tipo === 'TEF')[0].tipo
      if (labelCartao === 'TEF') {
        labelCartao = 'Cartão/TEF'
      }
    }

    const dinheiro = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'Dinheiro').length > 0;
    const pix = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'PIX').length > 0;

    if (cartao && dinheiro && pix) {
      return `${labelCartao}, Dinheiro e PIX`;
    }
    if (cartao && dinheiro) {
      return `${labelCartao} e dinheiro`;
    }
    if (cartao && pix) {
      return `${labelCartao} e PIX`;
    }
    if (dinheiro && pix) {
      return 'Dinheiro e PIX';
    }
    if (dinheiro) {
      return 'Dinheiro'
    }
    if (cartao) {
      return labelCartao
    }

    if (pix) {
      return 'PIX'
    }

    return 'Não informado'
  }

  exibirIconeSituacaoReserva (pedido) {
      return <span className="align-self-center tooltip-info">
                <a data-tip data-for={`situacao-reserva-${pedido.id}`}>
                  <i className="material-icons ajuda-icon" style={{ color: '#000' }}>&#xe147;</i>
                </a>
                <div className="tooltip-ut">
                  <ReactTooltip className="tooltip-ut" id={`situacao-reserva-${pedido.id}`}
                                type="dark" effect="solid">
                    <div className="row">Pedido contém reserva (s) na (s) situação (ões): {this.situacoesReservas()}</div>
                  </ReactTooltip>
                </div>
              </span>
  }

  exibirIconeCodigoPagamento (pedido) {
    if(!pedido.codigoTransacao)
      return ''
    return <span className="align-self-center tooltip-info">
                <a data-tip data-for={pedido.codigoTransacao}
                   onClick={(e)=> this.copyLink(e)}>
                  <i className="material-icons ajuda-icon" style={{ color: '#000' }}>&#xe147;</i>
                </a>
                <div className="tooltip-ut">
                  <ReactTooltip className="tooltip-ut" id={pedido.codigoTransacao}
                                type="dark" effect="solid">
                    <div className="row">{pedido.codigoTransacao}</div>
                    <div style={{color: '#fa8d42'}}>Clique no ícone para copiar o código!!</div>
                  </ReactTooltip>
                </div>
              </span>
  }

  exibirIconeIdaVoltaPedido (pedido) {
    const ehIdaVolta = Object.entries(this.groupArrayOfObjects(this.props.pedido.reservas, 'itinerarioId')).length > 1;
    return <span className="align-self-center tooltip-info">
              <a data-tip data-for={`data-embarque-${pedido.id}`}>
                {ehIdaVolta ?
                  <i className="material-icons ajuda-icon pedido" style={{ color: '#000' }}>&#xe8d4;</i>
                :
                  <i className="material-icons ajuda-icon pedido" style={{ color: '#000' }}>&#xe8e4;</i>}
                  </a>
              <div className="tooltip-ut">
              {ehIdaVolta ?
                <ReactTooltip className="tooltip-ut" id={`data-embarque-${pedido.id}`}
                              type="dark" effect="solid">
                    <div className="row">Data Ida: {this.exibeDataHoraPartida(pedido, 'IDA', ehIdaVolta)}</div>
                    <div className="row">Data Volta: {this.exibeDataHoraPartida(pedido, 'VOLTA', ehIdaVolta)}</div>
                </ReactTooltip>
                :
                <ReactTooltip className="tooltip-ut" id={`data-embarque-${pedido.id}`}
                              type="dark" effect="solid">
                    <div className="row">Data Ida: {this.exibeDataHoraPartida(pedido, 'IDA', ehIdaVolta)}</div>
                </ReactTooltip>}
              </div>
            </span>
}

  exibirIconeNomeAgencia (pedido) {
    if(!pedido.nomeAgencia){
      return ''
    }
    return <span className="align-self-center tooltip-info">
                <a data-tip data-for={`nome-agencia-${pedido.id}`}>
                  <i className="material-icons ajuda-icon" style={{ color: '#000' }}>&#xe147;</i>
                </a>
                <div className="tooltip-ut">
                  <ReactTooltip className="tooltip-ut" id={`nome-agencia-${pedido.id}`}
                                type="dark" effect="solid">
                    <div className="row">Agência: {pedido.nomeAgencia}</div>
                  </ReactTooltip>
                </div>
              </span>
  }

  exibeDataHoraPartida(pedido, tipo, ehIdaVolta) {
    var datas = null;
    var reservas = null;

    if(ehIdaVolta) {
      reservas = this.groupArrayOfObjects(pedido.reservas, 'dataHoraPartida')
      datas = Object.keys(reservas);

      var dataVolta = null;
      var dataIda = null;

      for(let i = 0; i < datas.length; i++) {
        datas.map((data) => {
          if(datas[i] > data) {
            dataVolta = datas[i]
          }
          if(datas[i] < data) {
            dataIda = datas[i]
          }
        })
      }

      if(tipo === 'IDA') {
        return dataIda;
      }

      if(tipo === 'VOLTA') {
        return dataVolta;
      }
    }

    if(!ehIdaVolta) {
      reservas = pedido.reservas

      reservas.forEach((it) => {
        datas = it.dataHoraPartida
      })

      return datas;
    }
  }

  situacoesReservas(){
    let situacoes = ''
    this.props.pedido.reservas.forEach((reserva,index) =>{
      situacoes += `${index > 0?  ' | ' : ''} ${capitalizarTodasPrimeirasLetras(reserva.situacaoReserva.replace('_',' '))}`
    })
    return situacoes
  }

  render () {
    return (
      <div className="geral">
        <div className="resumo">
          <div className="row">
            <div className="col-md-1 col-lg-1 col-xl-1" onClick={() => this.props.alterarExibicao(this.props.pedido)} style={{ cursor: 'pointer' }}>
              {this.exibirIcone()}
            </div>
            {validaPerfis([PERFIL_ADMIN]) && <div className="col-12 col-sm-12 col-md-1 col-lg-1 col-xl-1">
              <span className="titulo-mobile">Empresa:&nbsp;</span>{this.props.pedido.nomeFantasiaEmpresa}
            </div>}
            <div className="col-12 col-sm-12 col-md-1 col-lg-1 col-xl-1">
              <span className="titulo-mobile">Pedido:&nbsp;</span>{this.props.pedido.id}
            </div>
            <div className="col-md-2 col-lg-2 col-xl-2">
              <span className="titulo-mobile">Vendedor:&nbsp;</span>{this.props.pedido.nomeVendedor}
              {this.exibirIconeNomeAgencia(this.props.pedido) }
            </div>
            <div className="col-md-1 col-lg-2 col-xl-2">
              <span className="titulo-mobile">Cliente:&nbsp;</span>{this.props.pedido.nomeComprador}
            </div>
            <div className="col-md-1 col-lg-1 col-xl-1">
              <span className="titulo-mobile">Data da compra:&nbsp;</span>{this.props.pedido.data}
            </div>
            <div className="col-md-1 col-lg-1 col-xl-1">
              <span className="titulo-mobile">Situação:&nbsp;</span>{this.props.pedido.situacaoPedido}
              {this.exibirIconeSituacaoReserva(this.props.pedido) }
            </div>

            <div className="col-md-1 col-lg-1 col-xl-1">
              <span className="titulo-mobile">Valor:&nbsp;</span>{Number(this.props.pedido.valorTotalReservas).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
            </div>
            <div className="col-md-1 col-lg-1 col-xl-1">
              <span className="titulo-mobile">Pagamento:&nbsp;</span>{this.recuperaFormaPagamento()}
              {this.exibirIconeCodigoPagamento(this.props.pedido)}
            </div>
            {!validaPerfis([PERFIL_ADMIN]) && <div className="col-md-1 col-lg-1 col-xl-1">{this.exibirTextoIdaVolta()}
              <br/>
              {this.exibirIconeIdaVoltaPedido(this.props.pedido)}
            </div>}
            <div className="col-md-1 col-lg-1 col-xl-1">
                <AcoesPedido pedido={this.props.pedido}
                             empresaSelecionada={this.props.empresaSelecionada}
                              valoresDdiPassageiro={this.props.valoresDdiPassageiro}
                              usuarioBloqueadoEdicaoReimpressaoCupom={this.props.usuarioBloqueadoEdicaoReimpressaoCupom}
                              adicionarValoresDdiPassageiro={this.props.adicionarValoresDdiPassageiro.bind(this)}
                              removerValoresDdiPassageiro={this.props.removerValoresDdiPassageiro.bind(this)}
                              limparValoresDdiPassageiro={this.props.limparValoresDdiPassageiro.bind(this)} />
            </div>
          </div>
        </div>
        <DetalhesPedido pedido={this.props.pedido}/>
      </div>
    )
  }
}


export default (Pedido)
